import { render, staticRenderFns } from "./StatsCARatios.vue?vue&type=template&id=cc9868f6&scoped=true"
import script from "./StatsCARatios.vue?vue&type=script&lang=js"
export * from "./StatsCARatios.vue?vue&type=script&lang=js"
import style0 from "./StatsCARatios.vue?vue&type=style&index=0&id=cc9868f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc9868f6",
  null
  
)

export default component.exports